var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { deserialize, object } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { conditionRegistry } from '../../../registry/Registry';
import { Actor } from '../../actor/Actor';
import { editable } from '../../../utils/mobx/decorators/editable';
import { runtime } from '../../runtime/Runtime';
import { removeObsoleteConditionKeys } from '../../../utils/serializr/schema/specific/condition/removeObsoleteConditionKeys';
export class TraitCondition extends Actor {
    type = 'traitcondition';
    conditionKey = 'always';
    manualValue = null;
    condition_left;
    condition_right;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get reg() {
        let reg = conditionRegistry.registry_object[this.conditionKey];
        if (!reg) {
            console.log(`Kein ConditionRegistryItem für ${this.conditionKey}`);
            reg = conditionRegistry.registry_object['never'];
        }
        return reg;
    }
    get label() {
        if (runtime.availablePackages.Edit) {
            const condMeta = runtime.availablePackages.Edit.registryMetaInfo.conditions[this.conditionKey];
            if (condMeta && condMeta.label)
                return condMeta.label;
        }
        return (this.reg && this.reg.label) || this.conditionKey;
    }
    get trait() {
        return this.parent.type === 'trait' ? this.parent : this.parent.trait;
    }
    get parentCondition() {
        return this.parent.type === 'traitcondition' ? this.parent : undefined;
    }
    static fromSerialized(json = {}) {
        return deserialize(TraitCondition, json);
    }
    get recursiveConditions() {
        const all = [this];
        if (this.condition_left) {
            all.push(...this.condition_left.recursiveConditions);
        }
        if (this.condition_right) {
            all.push(...this.condition_right.recursiveConditions);
        }
        return all;
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                conditionKey: removeObsoleteConditionKeys,
                manualValue: true,
                condition_left: object(TraitCondition),
                condition_right: object(TraitCondition),
            },
        };
    }
}
__decorate([
    editable()
], TraitCondition.prototype, "conditionKey", void 0);
__decorate([
    editable()
], TraitCondition.prototype, "manualValue", void 0);
__decorate([
    editable('ref')
], TraitCondition.prototype, "condition_left", void 0);
__decorate([
    editable('ref')
], TraitCondition.prototype, "condition_right", void 0);
__decorate([
    computed
], TraitCondition.prototype, "reg", null);
__decorate([
    memoize
], TraitCondition, "serializeInfo", null);
